import { keyframes } from '@emotion/react';
import CachedIcon from '@mui/icons-material/Cached';
import { IconButton } from '@mui/material';

const refreshGlowAnimation = keyframes`
  0%, 100% {
    filter: drop-shadow(0 0 2px currentColor) drop-shadow(0 0 8px currentColor);
    transform: scale(1.1);
  }
  50% {
    filter: drop-shadow(0 0 4px currentColor) drop-shadow(0 0 10px currentColor);
    transform: scale(1.05);
  }
`;

export default function RefreshButton({ isGlowing = false, onClick }) {
  return (
    <IconButton color="primary" onClick={onClick} sx={{ scale: 1.5 }} aria-label="Refresh">
      <CachedIcon sx={isGlowing ? { animation: `${refreshGlowAnimation} 1s ease-in-out infinite` } : {}} />
    </IconButton>
  );
}
